package team.platforma.aicombo.activity.chat

import aicombo.composeapp.generated.resources.Res
import aicombo.composeapp.generated.resources.add
import aicombo.composeapp.generated.resources.arrow_left
import aicombo.composeapp.generated.resources.cross_m
import aicombo.composeapp.generated.resources.edit_2
import aicombo.composeapp.generated.resources.menu
import aicombo.composeapp.generated.resources.more
import aicombo.composeapp.generated.resources.play
import aicombo.composeapp.generated.resources.search
import aicombo.composeapp.generated.resources.stop
import androidx.compose.animation.core.FastOutSlowInEasing
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.VectorConverter
import androidx.compose.animation.core.animateValue
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.asPaddingValues
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.navigationBars
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.runtime.snapshotFlow
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.RectangleShape
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.isShiftPressed
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.onPreviewKeyEvent
import androidx.compose.ui.input.key.type
import androidx.compose.ui.input.pointer.PointerEventType
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardCapitalization
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Popup
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.FlowPreview
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.debounce
import kotlinx.coroutines.launch
import kotlinx.datetime.Clock
import org.jetbrains.compose.resources.painterResource
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.annotation.KoinExperimentalAPI
import team.platforma.accountmanagerlib.getAccountManager
import team.platforma.aicombo.activity.chat.component.ChatComponent
import team.platforma.aicombo.args.Arg
import team.platforma.aicombo.theme.colors.AppColors
import team.platforma.aicombo.theme.typography.FontWeights
import team.platforma.aicombo.theme.typography.Typography
import team.platforma.aicombo.utils.CLIPBOARD
import team.platforma.aicombo.utils.KeyBoardSpacer
import team.platforma.chat_presentation.ChatViewModel
import team.platforma.chat_presentation.Status
import team.platforma.deviceinfo.DEVICE
import team.platforma.dictionary_presentation.DictionaryViewModel
import team.platforma.extra_nav.component.activity_component.Activity
import team.platforma.extra_nav.component.activity_component.ActivityScaffold
import team.platforma.extra_nav.navigator.activity.findNavHost
import team.platforma.extra_nav.ui.nav_drawer.DrawerAlignment
import team.platforma.extra_nav.ui.nav_drawer.NavigationDrawer
import team.platforma.extra_nav.ui.side_sheet.SideSheet
import team.platforma.extra_nav.ui.side_sheet.SideSheetAlignment
import team.platforma.extra_nav.utils.Type
import team.platforma.extra_nav.utils.UI
import team.platforma.extra_nav.utils.rememberDeviceType
import team.platforma.extra_nav.utils.rememberKeyboardHeight
import team.platforma.extra_nav.utils.rememberUiOrientation
import team.platforma.multiplatform_material_extension.button.AppFilledButton
import team.platforma.multiplatform_material_extension.button.AppTextButton
import team.platforma.multiplatform_material_extension.scrollbar.VerticalScrollIndicator
import team.platforma.multiplatform_material_extension.text_input.TextInput
import team.platforma.multiplatform_material_extension.toolbar.Toolbar
import kotlin.coroutines.cancellation.CancellationException

@OptIn(ExperimentalMaterial3Api::class, KoinExperimentalAPI::class, FlowPreview::class)
object ChatActivity : Activity(
    route = "chat_activity",
    components = listOf(ChatComponent),
    activityScaffold = { components ->

        val dictionaryViewModel = koinViewModel<DictionaryViewModel>()
        val aiModels by dictionaryViewModel.observeAllAiModels()
            .collectAsState(initial = emptyList())

        val aiModelId = findNavHost().args() as? Long?

        val chatViewModel = koinViewModel<ChatViewModel>()
        val messages by chatViewModel.messages.collectAsState()

        DisposableEffect(Unit) {

            chatViewModel.apply {
                setUserId(getAccountManager().getUserId())
                setChatId(null)
                setAiModelId(aiModelId)
            }

            onDispose {
                chatViewModel.apply {
                    setAiModelId(null)
                    setChatId(null)
                    setUserId(null)
                }
            }

        }

        val keyboardHeight by rememberKeyboardHeight()
        val focusManager = LocalFocusManager.current

        var showSideSheet by remember { mutableStateOf(false) }

        val device by rememberDeviceType()

        NavigationDrawer(
            modifier = Modifier
                .background(AppColors.bg.default().default)
                .imePadding(),
            components = components,
            topBar = {
                Toolbar(
                    title = {
                        Text(
                            text = aiModels.find { it.id == aiModelId }?.name ?: ""
                        )
                    },
                    navigationIcon = {
                        IconButton(
                            onClick = {
                                chatViewModel.stopGeneration()
                                focusManager.clearFocus()
                                findNavHost().navigateBack()
                            }
                        ) {
                            Icon(
                                painter = painterResource(Res.drawable.arrow_left),
                                contentDescription = null
                            )
                        }
                    },
                    actions = {
                        IconButton(
                            onClick = {
                                chatViewModel.setChatId(null)
                            }
                        ) {
                            Icon(
                                painter = painterResource(Res.drawable.edit_2),
                                contentDescription = null
                            )
                        }

                        IconButton(
                            onClick = {
                                showSideSheet = true
                            }
                        ) {
                            Icon(
                                painter = painterResource(Res.drawable.menu),
                                contentDescription = null
                            )
                        }

                    }
                )
            },
            bottomBar = {

                val deviceType by rememberDeviceType()
                val orientation by rememberUiOrientation()

                val scope = rememberCoroutineScope()

                val viewModelDraft by chatViewModel.draft.collectAsState()
                var textPromptValue by remember {
                    mutableStateOf(
                        TextFieldValue("")
                    )
                }

//                LaunchedEffect(textPromptValue) {
//                    snapshotFlow { textPromptValue.text }
//                        .debounce(500) // ждем 500 мс после последнего изменения
//                        .collect { text ->
//                            val cleanedText = removeTailDuplication(text)
//                            if (cleanedText != textPromptValue.text) {
//                                val newCursor = minOf(textPromptValue.selection.start, cleanedText.length)
//                                textPromptValue = textPromptValue.copy(
//                                    text = cleanedText,
//                                    selection = TextRange(newCursor),
//                                    composition = null
//                                )
//                            }
//                        }
//                }
//                var lastConfirmedText by remember { mutableStateOf("") }

                LaunchedEffect(viewModelDraft.text) {
                    if (viewModelDraft.text != textPromptValue.text) {
                        val current = textPromptValue
                        val newCursor =
                            current.selection.start + 1
                        textPromptValue = current.copy(
                            text = viewModelDraft.text,
                            selection = TextRange(newCursor)
                        )
                    }
                }

                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    Column(
                        modifier = Modifier.width(
                            when (deviceType) {
                                Type.MOBILE -> {
                                    when (orientation) {
                                        UI.LANDSCAPE -> 600.dp
                                        UI.PORTRAIT -> 500.dp
                                    }
                                }

                                Type.TABLET -> 600.dp
                                Type.DESKTOP -> 800.dp
                            }
                        )
                    ) {
                        Box(
                            modifier = Modifier.fillMaxWidth()
                                .padding(start = 16.dp, end = 16.dp, bottom = 16.dp)
                                .background(AppColors.bg.base().default, RoundedCornerShape(6.dp))
                        ) {
                            Column(
                                modifier = Modifier.fillMaxWidth()
                            ) {

                                var isPressed by remember { mutableStateOf(false) }
                                var pressStartTime by remember { mutableStateOf(0L) }

                                val longPressThreshold = 500L // миллисекунд

                                var showPopUp by remember { mutableStateOf(false) }
                                val popupPosition = remember { mutableStateOf(Offset.Zero) }

//                                LaunchedEffect(isPressed) {
//                                    if (isPressed) {
//                                        pressStartTime = Clock.System.now().toEpochMilliseconds()
//                                        delay(longPressThreshold)
//                                        val now = Clock.System.now().toEpochMilliseconds()
//                                        if (isPressed && (now - pressStartTime >= longPressThreshold)) {
//                                            showPopUp = true
//                                        }
//                                    }
//                                }

                                if (showPopUp) {
                                    Popup(
                                        offset = IntOffset(
                                            popupPosition.value.x.toInt(),
                                            popupPosition.value.y.toInt() - 150
                                        ),
                                        onDismissRequest = { showPopUp = false }
                                    ) {
                                        Surface(
                                            shape = RoundedCornerShape(6.dp),
                                            color = MaterialTheme.colorScheme.surface,
                                            modifier = Modifier.widthIn(max = 160.dp).padding(4.dp)
                                                .shadow(4.dp, RoundedCornerShape(6.dp))
                                        ) {
                                            Column(
                                                modifier = Modifier.padding(4.dp)
                                            ) {
                                                val clipboardAvailable = CLIPBOARD.available()
                                                if (textPromptValue.text.isEmpty()) {
                                                    AppTextButton(
                                                        onClick = {
                                                            if (clipboardAvailable) {
                                                                try {
                                                                    scope.launch {
                                                                        val pasteText =
                                                                            CLIPBOARD.pasteFromClipboard()
                                                                        textPromptValue =
                                                                            TextFieldValue(
                                                                                text = pasteText,
                                                                                selection = TextRange(
                                                                                    pasteText.length,
                                                                                    pasteText.length
                                                                                )
                                                                            )
                                                                    }
                                                                } catch (_: Exception) {

                                                                } catch (_: CancellationException) {
                                                                }
                                                            }
                                                            showPopUp = false
                                                        },
                                                        modifier = Modifier.fillMaxWidth()
                                                    ) {
                                                        Text(text = "Вставить")
                                                    }
                                                }

                                            }
                                        }
                                    }
                                }

                                TextInput(
                                    modifier = Modifier.fillMaxWidth()
                                        .then(
                                            if (DEVICE.info().hardware == "Desktop") {
                                                Modifier.onPreviewKeyEvent { event ->
                                                    if (event.type == KeyEventType.KeyDown) {
                                                        when (event.key) {
                                                            Key.Enter -> {
                                                                if (event.isShiftPressed) {
                                                                    // Shift + Enter = вставка новой строки
                                                                    val current = textPromptValue
                                                                    if (current.text.isNotEmpty()) {
                                                                        val newText = buildString {
                                                                            append(
                                                                                current.text.substring(
                                                                                    0,
                                                                                    current.selection.start
                                                                                )
                                                                            )
                                                                            append("\n")
                                                                            append(
                                                                                current.text.substring(
                                                                                    current.selection.end
                                                                                )
                                                                            )
                                                                        }
                                                                        val newCursor =
                                                                            current.selection.start + 1
                                                                        textPromptValue =
                                                                            current.copy(
                                                                                text = newText,
                                                                                selection = TextRange(
                                                                                    newCursor
                                                                                )
                                                                            )
                                                                    }
                                                                } else {
                                                                    // Enter = отправка сообщения
                                                                    if (textPromptValue.text.isNotEmpty()) {
                                                                        chatViewModel.sendMessage(
                                                                            textPromptValue.text
                                                                        )
                                                                    }
                                                                }
                                                                true
                                                            }

                                                            Key.Escape -> {
                                                                if (messages.isNotEmpty() && messages.last().status == Status.Printing
                                                                    || messages.isNotEmpty() && messages.last().status == Status.Pending
                                                                ) {
                                                                    chatViewModel.stopGeneration()
                                                                }
                                                                true
                                                            }

                                                            else -> false
                                                        }
                                                    } else {
                                                        false
                                                    }
                                                }
                                            } else Modifier
                                        )
                                        .pointerInput(Unit) {
                                            awaitPointerEventScope {
                                                while (true) {
                                                    val event = awaitPointerEvent()

                                                    if (event.changes.size == 1 && event.type == PointerEventType.Press) {
                                                        popupPosition.value =
                                                            event.changes.first().position
                                                        isPressed = true
                                                    } else if (event.type == PointerEventType.Release) {
                                                        isPressed = false
                                                    }
                                                }
                                            }
                                        },
                                    value = textPromptValue,
                                    onValueChange = { newValue ->
                                        textPromptValue = newValue
                                        chatViewModel.updateDraftText(textPromptValue.text)
                                    },
                                    viewStyle = team.platforma.multiplatform_material_extension.text_input.style.TextInput.Style.Outline,
                                    colors = OutlinedTextFieldDefaults.colors().copy(
                                        focusedIndicatorColor = Color.Transparent,
                                        unfocusedIndicatorColor = Color.Transparent,
                                        cursorColor = AppColors.text().primary,
                                        focusedTextColor = AppColors.text().default,
                                        unfocusedTextColor = AppColors.text().default,
                                        focusedPlaceholderColor = AppColors.text().caption,
                                        unfocusedPlaceholderColor = AppColors.text().caption
                                    ),
                                    placeholder = {
                                        Text(
                                            text = "Спросите что-нибудь..."
                                        )
                                    },
                                    textStyle = Typography.textLg(FontWeights.Regular),
                                    maxLines = 6,
                                    keyboardOptions = KeyboardOptions(
                                        capitalization = KeyboardCapitalization.Words,
                                        autoCorrectEnabled = false,
                                        keyboardType = KeyboardType.Text,
                                        imeAction = ImeAction.Default,
                                    )
                                )

                                Row(
                                    modifier = Modifier.fillMaxWidth()
                                        .padding(
                                            top = 4.dp,
                                            start = 8.dp,
                                            end = 8.dp,
                                            bottom = 8.dp
                                        )
                                ) {
                                    IconButton(
                                        modifier = Modifier.size(40.dp),
                                        onClick = {

                                        }
                                    ) {
                                        Icon(
                                            painter = painterResource(Res.drawable.add),
                                            contentDescription = null,
                                            tint = AppColors.text().default
                                        )
                                    }

                                    Spacer(
                                        modifier = Modifier.weight(1f)
                                    )

                                    AppFilledButton(
                                        modifier = Modifier.size(40.dp),
                                        onClick = {
                                            if (messages.isNotEmpty() && messages.last().status == Status.Printing
                                                || messages.isNotEmpty() && messages.last().status == Status.Pending
                                            ) {
                                                chatViewModel.stopGeneration()
                                            } else {
                                                chatViewModel.sendMessage(textPromptValue.text)
                                            }

                                        },
                                        contentPadding = PaddingValues(0.dp),
                                        enabled = textPromptValue.text.isNotEmpty()
                                                || messages.isNotEmpty() && messages.last().status == Status.Printing
                                                || messages.isNotEmpty() && messages.last().status == Status.Pending
                                    ) {
                                        Box(
                                            modifier = Modifier.fillMaxSize(),
                                            contentAlignment = Alignment.Center
                                        ) {

                                            if (messages.isNotEmpty() && messages.last().status == Status.Printing
                                                || messages.isNotEmpty() && messages.last().status == Status.Pending
                                            ) {
                                                val infiniteTransition =
                                                    rememberInfiniteTransition()

                                                val size: Dp by infiniteTransition.animateValue(
                                                    initialValue = 16.dp,
                                                    targetValue = 20.dp,
                                                    typeConverter = Dp.VectorConverter,
                                                    animationSpec = infiniteRepeatable(
                                                        animation = tween(
                                                            durationMillis = 300,
                                                            easing = FastOutSlowInEasing
                                                        ), repeatMode = RepeatMode.Reverse
                                                    )
                                                )
                                                Icon(
                                                    painter = painterResource(Res.drawable.stop),
                                                    modifier = Modifier.size(size),
                                                    contentDescription = null
                                                )

                                            } else {
                                                Icon(
                                                    painter = painterResource(Res.drawable.play),
                                                    modifier = Modifier.size(16.dp),
                                                    contentDescription = null
                                                )
                                            }

                                        }
                                    }
                                }
                            }
                        }
//                        KeyBoardSpacer(keyboardHeight)
                    }
                }


            },
            drawer = {
                Box(
                    modifier = Modifier
                        .then(
                            Modifier.padding(
                                start = when (device) {
                                    Type.MOBILE, Type.TABLET -> 50.dp
                                    Type.DESKTOP -> 0.dp
                                }
                            )

                        )
                        .fillMaxHeight()
                        .width(400.dp)
                        .shadow(4.dp, shape = RectangleShape)
                        .background(AppColors.bg.base().default, shape = RectangleShape)
                        .clip(RectangleShape)
                ) {
                    Column(
                        modifier = Modifier.fillMaxWidth().statusBarsPadding()
                            .clickable(
                                indication = null,
                                interactionSource = remember { MutableInteractionSource() }
                            ) {}
                    ) {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            modifier = Modifier.padding(horizontal = 16.dp)
                        ) {
                            Text(
                                text = "Чаты",
                                style = Typography.textLg(FontWeights.Regular),
                                color = AppColors.text().caption,
                                modifier = Modifier.weight(1f).padding(start = 12.dp)
                            )
                            IconButton(
                                onClick = {
                                    showSideSheet = false
                                }
                            ) {
                                Icon(
                                    painter = painterResource(Res.drawable.cross_m),
                                    contentDescription = null,
                                    tint = AppColors.text().default
                                )
                            }

                        }
                        HorizontalDivider(
                            modifier = Modifier.fillMaxWidth().height(1.dp)
                                .padding(horizontal = 16.dp),
                            color = AppColors.border().default
                        )
                        Spacer(
                            modifier = Modifier.height(16.dp)
                        )

                        AppTextButton(
                            onClick = {
                                chatViewModel.setChatId(null)
                                when (device) {
                                    Type.MOBILE, Type.TABLET -> {
                                        showSideSheet = false
                                    }
                                    Type.DESKTOP -> {}
                                }

                            },
                            modifier = Modifier.padding(horizontal = 16.dp).fillMaxWidth(),
                            contentPadding = PaddingValues(8.dp),
                        ) {
                            Row(
                                modifier = Modifier.fillMaxWidth(),
                                horizontalArrangement = Arrangement.Start
                            ) {
                                Icon(
                                    painter = painterResource(Res.drawable.edit_2),
                                    contentDescription = null,
                                    modifier = Modifier.size(16.dp)
                                )
                                Text(
                                    text = "Новый чат",
                                    style = Typography.textLg(FontWeights.Regular),
                                    modifier = Modifier.padding(horizontal = 8.dp)
                                )
                            }

                        }

                        Spacer(
                            modifier = Modifier.height(4.dp)
                        )

                        AppTextButton(
                            onClick = {

                            },
                            modifier = Modifier.padding(horizontal = 16.dp).fillMaxWidth(),
                            contentPadding = PaddingValues(8.dp),
                        ) {
                            Row(
                                modifier = Modifier.fillMaxWidth(),
                                horizontalArrangement = Arrangement.Start
                            ) {
                                Icon(
                                    painter = painterResource(Res.drawable.search),
                                    contentDescription = null,
                                    modifier = Modifier.size(16.dp)
                                )
                                Text(
                                    text = "Поиск в чатах",
                                    style = Typography.textLg(FontWeights.Regular),
                                    modifier = Modifier.padding(horizontal = 8.dp)
                                )
                            }

                        }

                        Spacer(
                            modifier = Modifier.height(8.dp)
                        )

                        HorizontalDivider(
                            modifier = Modifier.fillMaxWidth().height(1.dp)
                                .padding(horizontal = 16.dp),
                            color = AppColors.border().default
                        )

                        val chats by chatViewModel.chats.collectAsState()

//                            print("CHATS LIST: $chats")


                        val state = rememberLazyListState()

                        VerticalScrollIndicator(
                            state = state
                        ) {
                            LazyColumn(
                                contentPadding = PaddingValues(
                                    top = 16.dp,
                                    bottom = 16.dp + WindowInsets.navigationBars.asPaddingValues()
                                        .calculateBottomPadding()
                                ),
                                verticalArrangement = Arrangement.spacedBy(8.dp),
                                state = state
                            ) {
                                items(chats) { item ->
                                    AppTextButton(
                                        onClick = {
//                                                chatViewModel.setChatId(item.id)
                                            chatViewModel.updateChat(item.id)
                                            when (device) {
                                                Type.MOBILE, Type.TABLET -> {
                                                    showSideSheet = false
                                                }
                                                Type.DESKTOP -> {}
                                            }
//                                            showSideSheet = false
                                        },
                                        modifier = Modifier.padding(horizontal = 16.dp)
                                            .fillMaxWidth(),
                                        contentPadding = PaddingValues(
                                            start = 8.dp,
                                            top = 8.dp,
                                            bottom = 8.dp,
                                            end = 8.dp
                                        ),
                                    ) {
                                        Row(
                                            modifier = Modifier.fillMaxWidth(),
                                            horizontalArrangement = Arrangement.Start,
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            Text(
                                                text = item.name,
                                                style = Typography.textLg(FontWeights.Regular),
                                                modifier = Modifier.weight(1f)
                                                    .padding(horizontal = 8.dp),
                                                maxLines = 1,
                                                overflow = TextOverflow.Ellipsis
                                            )

                                            IconButton(
                                                onClick = {},
                                                modifier = Modifier.size(30.dp)
                                            ) {
                                                Icon(
                                                    painter = painterResource(Res.drawable.more),
                                                    contentDescription = null,
                                                    modifier = Modifier.size(24.dp)
                                                )
                                            }
                                        }

                                    }
                                }
                            }
                        }

                    }
                }
            },
            onDismissRequest = {
                showSideSheet = false
            },
            showDrawer = showSideSheet,
            drawerAlignment = DrawerAlignment.Right,
            coverContent = when (device) {
                Type.MOBILE, Type.TABLET -> true
                Type.DESKTOP -> false
            }
        )

    }
)
